import { Outlet } from "react-router-dom";

const ErrorPageLayout = () => {

    return (
        <>

            <div className="main-section">
                <Outlet />
            </div>
        </>
    );
};

export default ErrorPageLayout;
